import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Component } from 'react';
import axios from "axios";
import * as Constanti from './Utils/constants.js';

import CustomHeader from './components/header/header';
import Home from './components/home/home';
import DettaglioCategoria from './components/dettaglioCategoria/categoriaDetail.js';
import DettaglioVideo from './components/video/videoDetail.js';
import Footer from './components/footer/footer.js';
import ProtagonistaDetail from './components/protagonisti/protagonistaDetail.js';
import ScrollToTop from './components/hooks/ScrollToTop.js';
import EventsDetail from './components/share/eventsDetail.js';
import NewsDetail from './components/share/newsDetail.js';
import { withRouter } from './components/hooks/navigation.js';
import HeaderShare from './components/header/headerShare.js';
import MainLayout from './components/header/MainLayout.js';
import AltLayout from './components/header/AltLayout.js';


 

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categorie: [],
    };
  }

  componentDidMount() {
    var apiBaseUrl = Constanti.url_Backend + "getAllCategory";
    axios.get(apiBaseUrl)
      .then((response) => {
        if (response.data.data != null) {
          this.setState({ categorie: response.data.data });
        } else {
          console.log("non ci categorie");
        }
        this.setState({ load: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ load: false });
      });
  }

  render() {
    const { categorie } = this.state;
    return (
      <div className="App">
          <Router>
          <Routes>
            {/* layout normale */}
            <Route element={<MainLayout categorie={categorie} />}>
              <Route path="/" element={<Home categorie={categorie} />} />
              <Route path="/categoria/:id" element={<DettaglioCategoria />} />
              <Route path="/video/:id" element={<DettaglioVideo />} />
              <Route path="/protagonisti/:id" element={<ProtagonistaDetail />} />
            </Route>

            {/* layout alternativo per news/events */}
            <Route element={<AltLayout />}>
              <Route path="/news/:id/:idCat" element={<NewsDetail />} />
              <Route path="/events/:id" element={<EventsDetail />} />
            </Route>
          </Routes>
        </Router>
      </div>
    );
  }
}

export default App; 
